import React from 'react';
import { CheckCircleIcon, TruckIcon } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = ['Professional courier drivers available for hire at short notice', 'Experienced, vetted, and fully insured drivers', 'Nationwide driver coverage across the UK', 'Emergency item and parcel delivery services', 'Flexible hiring — single jobs or long-term contracts', 'Trusted by businesses across the UK for driver supply'];
  return <section className="py-20 bg-slate-900 text-white overflow-hidden relative" data-id="element-212">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/10 -skew-x-12 transform origin-top-right z-0 hidden lg:block" data-id="element-213" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-214">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-215">
          <div className="lg:w-1/2" data-id="element-216">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-217">
              Why Choose Universal Global Logistics
            </h2>

            <ul className="space-y-6" data-id="element-218">
              {reasons.map((reason, index) => <li key={index} className="flex items-start" data-id="element-219">
                  <CheckCircleIcon className="h-6 w-6 text-primary shrink-0 mr-4 mt-0.5" data-id="element-220" />
                  <span className="text-lg text-slate-200" data-id="element-221">{reason}</span>
                </li>)}
            </ul>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-222">
            <div className="relative rounded-2xl overflow-hidden bg-slate-800 aspect-video flex items-center justify-center border border-slate-700 shadow-2xl" data-id="element-223">
              <img src="https://images.unsplash.com/photo-1570710891163-6d3b5c47248b?w=800" alt="Diverse delivery team" className="absolute inset-0 w-full h-full object-cover opacity-80" data-id="element-224" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" data-id="element-225" />
              <div className="absolute bottom-6 left-6 right-6 bg-slate-900/80 backdrop-blur p-4 rounded-xl border border-slate-700" data-id="element-226">
                <p className="text-center font-medium text-slate-300" data-id="element-227">
                  Delivering excellence across the United Kingdom
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}